// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
const borderStyle = `2px solid ${"var(--ds-border, #091E4224)"}`;
export const maxContentWidth = {
  medium: '680px',
  // 552px (medium width) + 64px + 64px (padding left and right)
  large: '832px',
  // 704px (large width) + 64px + 64px (padding left and right)
  xlarge: '1048px',
  // 920px (xlarge width) + 64px + 64px (padding left and right)
  full: 'none'
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const FooterButtonsWrapper = styled.div({
  flexShrink: 0,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> button': {
    marginRight: "var(--ds-space-100, 8px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '> button:last-child': {
    marginRight: 0
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const FooterInfoTextWrapper = styled.div({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text, #172B4D)",
  fontWeight: "var(--ds-font-weight-semibold, 600)",
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  alignSelf: 'center'
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-flow: row nowrap;
	gap: ${"var(--ds-space-100, 8px)"};
	width: 100%;
	padding: ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-800, 64px)"};
	box-sizing: border-box;
	flex-shrink: 0;
	margin: 0 auto 0 auto;
	max-width: ${({
  contentSize
}) => maxContentWidth[contentSize]};

	@media (max-width: 479px) {
		flex-flow: column nowrap;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const HorizontalDivider = styled.hr({
  border: 0,
  margin: 0,
  width: '100%',
  borderBottom: borderStyle
});